import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarRef, MatSnackBarVerticalPosition } from "@angular/material/snack-bar";
import { Pet24snackbarComponent } from "./pet24snackbar/pet24snackbar.component";

export class CommonComponent {
    errors: string[] = [];
    horizontalPosition: MatSnackBarHorizontalPosition = 'end';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
    styleSnack = {
        success: 'success-petsnackbar',
        error:   'error-petsnackbar',
        info:    '',
        warning: 'warning-petsnackbar',
        primary: ''
      };
    constructor(
        private _snackBar: MatSnackBar
    ){}
    
    catchError(error: any) {
        if (error.status === 500) {
            this.errors.push('Ocurrio un error en el servidor');
        } else {
            this.errors.push(JSON.stringify(error.message || ''));
        }
        console.log('error : ' + JSON.stringify(error));
    }

    openSnackBar(msj: string, duration: number = 4, type: string = 'error'): MatSnackBarRef<any> {
        return this._snackBar.openFromComponent(Pet24snackbarComponent, {
          horizontalPosition: this.horizontalPosition,
          verticalPosition: this.verticalPosition,
          duration: duration * 1000,
          data: { message: msj, type: type },
          panelClass: this.styleSnack[type]
        });
    }
}
